"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllCookies = getAllCookies;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.setJsonCookie = setJsonCookie;
exports.getJsonCookie = getJsonCookie;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getAllCookies() {
  var allCookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.cookie;
  var prepareCookies = allCookies.split(';');
  var cookieObj = {};

  for (var i = 0; prepareCookies.length > i; i++) {
    var cookie = prepareCookies[i].trim().split('=');
    Object.assign(cookieObj, _defineProperty({}, cookie[0], cookie[1]));
  }

  return cookieObj;
}

function getCookie(cookieName) {
  var nameEquals = cookieName + '=';
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1, c.length);
    }

    if (c.indexOf(nameEquals) == 0) return c.substring(nameEquals.length, c.length);
  }

  return null;
}

function setCookie(name, value, options) {
  var cookieVal = "".concat(name, "=").concat(value),
      expires = options && options.expires ? "expires=".concat(options.expires.toUTCString()) : '',
      domain = options && options.domain ? "domain=".concat(options.domain) : '',
      maxAge = options && options.maxAge ? "max-age=".concat(options.maxAge) : '',
      secure = options && options.secure ? 'secure' : '';
  document.cookie = [cookieVal, maxAge, expires, domain, secure].filter(Boolean).join(';');
}

function setJsonCookie(name, json, options) {
  setCookie(name, JSON.stringify(json), options);
}

function getJsonCookie(name) {
  var cookieRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.cookie;
  var allCookies = getAllCookies(cookieRef);
  var cookieVal = allCookies[name];

  if (cookieVal) {
    try {
      return JSON.parse(cookieVal);
    } catch (e) {
      return undefined;
    }
  } else return undefined;
}